import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTopSkillsByISCO4 = async (HubIds: string[], ISCO4Codes?: string[]) => {
    const { path, method } = endpoints.skill.getTopSkillsByISCO4;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, ISCO4Codes },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
